import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import ProcedureManual_Form from "./procedureManual_Form/ProcedureManual_Form";
import ProcedureManual_table from "./procedureManual_table/ProcedureManual_table";

function ProcedureManual() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Procedure Manual" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
          The Procedure Manual provides detailed step-by-step instructions for all laboratory activities, ensuring consistency, accuracy, and compliance with quality standards. It guides staff in performing tests, handling equipment, maintaining records, and managing files systematically to achieve reliable and traceable results.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <ProcedureManual_Form />
        </div>

        <div className="imperiality_table_div">
          <ProcedureManual_table />
        </div>

 <div className="m-3">

        <div className="add_another_holder">
          <div>
            <span>
              <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
            </span>
          </div>
        </div>
 </div>
      </section>
    </>
  );
}

export default ProcedureManual;
